import { fireReactGAEvent } from '../../components/Questions/utils'
import { VehicleDetailsDataObject } from '../../services/vehicle-service'

interface VehiclesApiClientErrorBody {
  message: string
}

export const getVehicleIdentity = async (vrm: string): Promise<VehicleDetailsDataObject> => {
  fireReactGAEvent({
    category: 'Application Form',
    action: 'Vehicle Lookup',
    label: vrm,
    nonInteraction: true
  })

  const response = await fetch(`/api/app-form/vehicles-api?vrm=${encodeURIComponent(vrm)}`)

  if (!response.ok) {
    const errorBody: VehiclesApiClientErrorBody = await response
      .json()
      .catch(() => ({ message: 'Failed to look up vehicle' }))
    throw new Error(errorBody.message)
  }

  return response.json()
}
